import React from "react";
import logo from "../media/logo.png";
import Float from "../ui/Float";
import Space from "../ui/Space";
import Label from "../ui/Label";
import ConsoleClockPing from "./ConsoleClockPing";
import { useSignal, useSignals } from "@preact/signals-react/runtime";
import { useGlobals } from "../hooks/Globals";
import StoreSelector from "./StoreSelector";
import { kbdEvent } from "../utils/Utils";
import { KBD } from "../utils/Keybindings";
import { AlarmIcon, BugIcon, CartIcon, ChatIcon, UndoIcon } from "../utils/Icons";
import ScheduleChecker from "./ScheduleChecker";
import { getSignal } from "../App";
import Input from "../ui/Input";
import HeaderSearchInput from "../ui/HeaderSearchInput";
import { drawProductSearch, drawKeywordSearch, drawBugReport } from "../controllers/GlobalController";
import Button from "../ui/Button";
export default function ConsoleHeader(props) {

    useSignals();
    const { controller = "", title = "", is_modal = false } = props;
    const signal = getSignal();
    const _title = (title) ? title : signal?.title;
    const _clerk_code = (signal?.session?.clerk_code) ? signal?.session?.clerk_code : ""
    const _clerk_name = (signal?.session?.clerk_name) ? signal?.session?.clerk_name : ""
    const _station = (signal?.session?.station) ? signal?.session?.station : ""
    const show_back = signal?.show_back || false;


    const goHome = () => {
        const event = new CustomEvent("switchController", { detail: "home" });
        window.dispatchEvent(event);
    }

    const showSearch = () => {
        drawProductSearch({
            controller: controller, return_search: true, callback: (_obj) => {

            }
        })
    }



    const drawSearch = () => {
        if (window.beta) return <></>;

        return (
            <HeaderSearchInput
                onSearch={drawKeywordSearch}
                onAdvancedSearch={(keyboard_event = {}) => {
                    drawProductSearch({ keyboard_event });
                }}
            />
        );
    };

    return (
        <div className="console-header" style={{ "padding": "0px 15px" }}>
            <div style={{ height: "55px", display: "grid", gridTemplateColumns: "max-content minmax(0, 1fr) max-content", alignItems: "center", gap: "20px", minWidth: 0, }}>
                <div style={{ flexShrink: 0 }}>
                    <Space style={{ "alignItems": "center" }} size={6}>
                        <div style={{ "marginLeft": "10px", opacity: (signal?.route === "home.menu") ? "0.5" : "1" }}>
                            <button onClick={() => kbdEvent(KBD.ESCAPE)} className="ui-btn"><UndoIcon /></button>
                        </div>
                        <div></div>
                        <div style={{ "fontSize": "18px" }} className="hotkey"><nobr> &nbsp;{_title} </nobr></div>
                    </Space>
                </div>
                <div style={{ width: "100%", maxWidth: "600px", minWidth: 0, justifySelf: "center", }}>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        minWidth: 0,
                    }}>
                        <div style={{
                            flex: "1 1 auto",
                            minWidth: 0
                        }}>
                            {drawSearch()}
                        </div>
                        <div style={{ flexShrink: 0 }}>
                            <ConsoleClockPing />
                        </div>
                    </div>
                </div>
                <div style={{ flexShrink: 0, marginLeft: "auto" }}>
                    <Space style={{ "alignItems": "center" }} size={10}>
                        <nobr><StoreSelector controller={controller} /></nobr>
                        <div style={{ borderLeft: "1px solid var(--border-primary)", "marginTop": "-4px", "height": "22px" }}></div>
                        <Space size={8}>
                            <a className="icon-link"><ChatIcon /></a>
                            <Label className="bold" >0</Label>
                        </Space>
                        {(!window.beta &&
                            <>
                                <div style={{ borderLeft: "1px solid var(--border-primary)", "marginTop": "-4px", "height": "22px" }}></div>
                                <Space size={8}>
                                    <a className="icon-link" onClick={(e) => { e.preventDefault(); drawBugReport(e.currentTarget); }} ><BugIcon /></a>
                                </Space>
                            </>
                        )}

                        <div style={{ borderLeft: "1px solid var(--border-primary)", "marginTop": "-4px", "height": "22px" }}></div>
                        <Space size={8}>
                            <a className="icon-link"><CartIcon /></a>
                            <Label className="bold" >0</Label>
                        </Space>
                        <div style={{ borderLeft: "1px solid var(--border-primary)", "marginTop": "-4px", "height": "22px" }}></div>
                        <Space size={8}>
                            <ScheduleChecker />
                        </Space>
                        <div style={{ borderLeft: "1px solid var(--border-primary)", "marginTop": "-4px", "height": "22px" }}></div>
                        <Label className="bold" style={{ "color": "var(--text)" }} >#{_station} {_clerk_code}{(_clerk_name && ` (${_clerk_name})`)}</Label>
                        <div></div>
                        <Button onClick={() => kbdEvent(KBD.F6)} type="secondary">Sign in</Button>
                    </Space>
                </div>
            </div>
        </div>
    )
}